module.exports = __webpack_public_path__ + "img/doctor_bg.9b8e403e.png";